import React, { useState, useEffect } from "react";

const TypewriterComponent = ({ children, speed = 50 }) => {
    // Ensure children is always a string
    const text = typeof children === "string" ? children : "";
    const [visibleLetters, setVisibleLetters] = useState(0);

    useEffect(() => {
        setVisibleLetters(0); // Reset when text changes
        const interval = setInterval(() => {
            setVisibleLetters((prev) => {
                if (prev < text.length) {
                    return prev + 1;
                } else {
                    clearInterval(interval);
                    return prev;
                }
            });
        }, speed);

        return () => clearInterval(interval);
    }, [text, speed]);

    return (
        <>
            {text.split("").map((char, index) => (
                <span key={index} style={{ color: index < visibleLetters ? "black" : "rgba(0, 0, 0, 0.2)" }}>
                    {char}
                </span>
            ))}
        </>
    );
};

export default TypewriterComponent;
